import BaseApi from '@/api/BaseApi';
import type { IPaginate } from '@/models/TableSettingsModel';
import type { IAdminResponse, ICreateEditAdminRequest } from '@/models/AdminModel';

export default class AdminApi extends BaseApi {
	async deleteAdmin (adminId: number) {
		return this.delete({
			url: `/api/users/${adminId}`,
		});
	};

	async createAdmin (payload: ICreateEditAdminRequest) {
		return this.post<ICreateEditAdminRequest, any>({
			url: `/api/users`,
            data: payload,
		});
	};

	async editAdmin (payload: ICreateEditAdminRequest, adminId: string | string[]) {
		return this.put<ICreateEditAdminRequest, any>({
			url: `/api/auth/profile/${adminId}`,
            data: payload,
		});
	};

	async adminDetails (adminId: string | string[]) {
		return this.get<IAdminResponse>({
			url: `/api/users/${adminId}`,
		});
	};

    async adminsList (warehouseId: string | string[], page: number, perPage: number, sortBy: string | null, sortDesc: string | null, search: string | null) {
        let url = `/api/warehouses/${warehouseId}/users?role=wholesaler&page=${page}&per_page=${perPage}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        if (null != search) {
            url += `&search=${search}`;
        }

        return this.get<IPaginate<IAdminResponse>>({
            url: url,
        });
    };
};
